type FormatCurrencyType = {
  value: string | number;
  currency?: string;
  maximumFractionDigits?: number;
};

const formatCurrency = ({ value, currency = 'USD', maximumFractionDigits = 0 }: FormatCurrencyType) => {
  const numericValue = typeof value === 'string' ? Number.parseFloat(value) : value;

  if (!Number.isFinite(numericValue)) {
    return '-';
  }

  return new Intl.NumberFormat('en-US', { style: 'currency', currency, maximumFractionDigits }).format(numericValue);
};

export default formatCurrency;
